import { forwardRef } from "react";
import {
  Dialog as MuiDialog,
  DialogProps,
  IconButton,
  Slide,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/CancelSharp";
import { mergeWith } from "lodash";

import { colors } from "theme";

const useStyles = makeStyles(() => ({
  paper: {
    maxWidth: "560px !important",
    "& > .MuiDialogTitle-root": {
      paddingBottom: 0,
    },
    "& > .MuiDialogContent-root": {
      padding: "32px 24px",
    },
  },
}));

const otherStyles = makeStyles(() => ({
  closeButton: {
    position: "absolute",
    right: 20,
    top: 17.5,
  },
  closeIcon: {
    color: colors.grey[300],
  },
}));

const Transition = forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<any>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ClosableDialog = forwardRef(
  ({ classes = {}, children, ...otherProps }: DialogProps, ref: any) => {
    const otherClasses = otherStyles();
    const baseClasses = useStyles();
    const dialogClasses = mergeWith(
      baseClasses,
      classes,
      (class1: string, class2: string) => `${class1} ${class2}`
    );

    return (
      <MuiDialog
        ref={ref}
        TransitionComponent={Transition}
        {...otherProps}
        classes={dialogClasses}
      >
        {children}
        {!!otherProps.onClose && (
          <IconButton
            aria-label="close"
            className={otherClasses.closeButton}
            onClick={(evt) => otherProps.onClose!(evt, "backdropClick")}
            size="large"
          >
            <CloseIcon className={otherClasses.closeIcon} />
          </IconButton>
        )}
      </MuiDialog>
    );
  }
);

export default ClosableDialog;
